import { render, staticRenderFns } from "./DtailPageRight.vue?vue&type=template&id=001eae7e&scoped=true"
import script from "./DtailPageRight.vue?vue&type=script&lang=js"
export * from "./DtailPageRight.vue?vue&type=script&lang=js"
import style0 from "./DtailPageRight.vue?vue&type=style&index=0&id=001eae7e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001eae7e",
  null
  
)

export default component.exports